import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { createInitialUiState, UiModel, UiArea } from './ui.models';
import { iStoreActions } from '../../../loan-state/core/store-actions.interface';

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'ui' })
export class UiStore extends Store<UiModel> implements iStoreActions<UiModel> {
  constructor() {
    super(createInitialUiState());
  }

  preInitialize() {
    this.update({
      isUnsavedChangesModalNeeded: false,
      unsavedChangesMessage: '',
      unsavedChangesAcceptLabel: '',
      unsavedChangesRejectLabel: '',
      unsavedChangesAreaId: UiArea.none,
    });
  }

  resetUnsavedChanges() {
    this.update({
      isUnsavedChangesModalNeeded: false,
      unsavedChangesMessage: '',
      unsavedChangesAcceptLabel: '',
      unsavedChangesRejectLabel: '',
      unsavedChangesAreaId: UiArea.none,
    });
  }
}
